import { render, staticRenderFns } from "./BroadcastMessage.vue?vue&type=template&id=77ce621d&scoped=true&"
import script from "./BroadcastMessage.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessage.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastMessage.vue?vue&type=style&index=0&id=77ce621d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ce621d",
  null
  
)

export default component.exports